import styled from 'styled-components';

export const ImageContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-radius: 13px;
`;

export const EmptyThumbnail = styled.div`
  grid-area: thumbnail;
  width: 205px;
  border-radius: 13px;
  border: 1px solid #dbdbdb;
  background-color: #f2f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  font-family: Poppins;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  text-align: center;
  color: #616161;
`;

export const ThumbnailContainer = styled.div`
  grid-area: thumbnail;
  width: 205px;
  height: 199px;
  border-radius: 13px;
  border: 1px solid #dbdbdb;
  padding: 10px;
  display: flex;
  justify-content: center;
`;
